import { z } from 'zod'

import { nullableString, serverItemSchema } from '../utils/schema'

const installationDetailSchema = serverItemSchema.merge(
  z.object({
    deviceType: nullableString,
    os: nullableString,
    appVersion: nullableString,
    name: nullableString,
  })
)

export { installationDetailSchema }
